const defaultLogs = [];
const boxLogs = (state = defaultLogs, action) => {
  switch (action.type) {
    case 'GET_LOGS_SUCCESS':
      return action.boxLogs;
    default:
      return state;
  }
};

export default boxLogs;